import { BatteryFullIcon, CellSignalFullIcon, WifiHighIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

import { cx } from '@/ui/classNames';

import styles from './PhoneFrame.module.css';

interface PhoneFrameProps {
  /** Description de l'écran pour les lecteurs d'écran. */
  readonly label: string;
  readonly className?: string;
  /** L'application affichée, en vrai HTML. */
  readonly children: ReactNode;
}

/**
 * Un téléphone : coque, îlot, barre d'état et barre d'accueil. L'écran est en
 * vrai HTML et toute l'interface est en `em` : elle se met à l'échelle de la
 * largeur du téléphone, nette à toutes les tailles.
 */
export function PhoneFrame({ label, className, children }: PhoneFrameProps) {
  return (
    <div className={cx(styles.phone, className)} role="img" aria-label={label}>
      <div className={styles.screen} aria-hidden="true">
        <div className={styles.statusBar}>
          <span>9:41</span>
          <span className={styles.island} />
          <span className={styles.indicators}>
            <CellSignalFullIcon weight="fill" />
            <WifiHighIcon weight="bold" />
            <BatteryFullIcon weight="fill" />
          </span>
        </div>
        <div className={styles.app}>{children}</div>
        <span className={styles.homeIndicator} />
      </div>
    </div>
  );
}
